// extracted by mini-css-extract-plugin
export default {"overlay":"XB-z","bodyOpen":"YB-z","content":"ZB-z","header":"_B-z","close":"aC-z","closeNoHeading":"bC-z"};